import React from 'react'
import Modal from '../../Modal'
import Button from '../../Button'
import WarningIcon from 'react-icons/lib/fa/exclamation-circle'
import './WarningModal.scss'

export default function WarningModal(props) {
    const {warningModalData, onClose} = props
    const {message, confirmText, cancelText, onConfirm, students} = warningModalData

    return <Modal isOpen={true} renderCloseIcon={false} onClose={onClose}>
        <div className='warning-modal'>
            <div className='warning-modal-content'>
                <div className='warning-modal-text'>
                    <div>{message}</div>
                    {renderStudents()}
                </div>
                <WarningIcon />
            </div>
            <div className='warning-modal-controls'>
                <Button onClick={onConfirm}>{confirmText}</Button>
                <Button type='secondary' onClick={onClose}>{cancelText}</Button>
            </div>
        </div>
    </Modal>

    function renderStudents() {
        if (!students) return
        const names = students.map(s => `${s.first_name} ${s.last_name}`).join(', ')
        return <div>
            <div style={{marginTop:20}}>{names}</div>
            <div style={{marginTop:20}}>Proceed with all the other students?</div>
        </div>
    }
}